
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lesson/[lessonSlug]/[lessonUID]",
      function () {
        return require("private-next-pages/lesson/[lessonSlug]/[lessonUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lesson/[lessonSlug]/[lessonUID]"])
      });
    }
  